import request from '@/utils/request'

/**
 * 获取系统用户列表
 * @param {Object} params
 * @param {number} params.page - 当前页码
 * @param {number} params.page_size - 每页条数
 * @param {string} params.search - 搜索关键词
 */
export function getUserList(params) {
  return request.get('/users/admin/get_all_users', params)
}

/**
 * 删除用户
 * @param {number} userId - 用户ID
 */
export function deleteUser(userId) {
  return request.post('/users/admin/delete_user', { user_id: userId })
}

/**
 * 更新用户角色
 * @param {number} userId - 用户ID
 * @param {number} isAdmin - 是否为管理员(1:管理员, 0:普通用户)
 */
export function updateUserRole(userId, isAdmin) {
  return request.post('/users/admin/update_role', { 
    user_id: userId,
    admin: isAdmin 
  })
} 